/** Meta / Vercel avatar URLs for conversation UI (KISS–DRY). */

export function normalizeProfilePicUrl(url?: string | null): string | undefined {
  const t = url?.trim()
  return t || undefined
}

/**
 * Stable key for avatar.vercel.sh: email → userId → display name slug → "user".
 */
export function getVercelAvatarKey(email: string, userId: string, displayName: string): string {
  const e = email?.trim()
  if (e && e.includes("@")) return e
  const uid = userId?.trim()
  if (uid) return uid
  const n = displayName?.trim()
  if (n) {
    const slug = n
      .replace(/\s+/g, "-")
      .replace(/[^a-zA-Z0-9\-_.]/g, "")
      .slice(0, 64)
    if (slug) return slug
  }
  return "user"
}

export function getVercelAvatarUrl(key: string): string {
  return `https://avatar.vercel.sh/${encodeURIComponent(key)}`
}

export function getContactAvatarInitials(displayName: string): string {
  const parts = displayName.trim().split(/\s+/).filter(Boolean)
  if (!parts.length) return "?"
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}
